import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import memoize from 'lodash.memoize';
import { pathOr, concat, pick } from 'ramda';

import { actions } from '../actions/boardgames';

const byId = (state = {}, action) => {
  switch (action.type) {
    case actions.GET_GALLERY_FOR_BOARDGAME_SUCCESS: {
      const { id, page, data } = action.payload;
      return page === 1
        ? Object.assign({}, state, {
          [id]: pathOr([], ['images'], data)
        })
        : Object.assign({}, state, {
          [id]: concat(pathOr([], [id], state), pathOr([], ['images'], data))
        });
    }
    default:
      return state;
  }
};

const configById = (state = {}, action) => {
  switch (action.type) {
    case actions.GET_GALLERY_FOR_BOARDGAME_SUCCESS: {
      const { id, data } = action.payload;
      return Object.assign({}, state, {
        [id]: pick(['numitems', 'endpage'], pathOr({}, ['config'], data)),
      });
    }
    default:
      return state;
  }
};

const loading = (state = false, action) => {
  switch (action.type) {
    case actions.GET_GALLERY_FOR_BOARDGAME_REQUEST:
      return true;
    case actions.GET_GALLERY_FOR_BOARDGAME_SUCCESS:
    case actions.GET_GALLERY_FOR_BOARDGAME_FAILED:
      return false;
    default:
      return state;
  }
};

const galleries = combineReducers({
  byId,
  configById,
  loading,
});

export default galleries;

export const galleriesSelector = state => state.galleries.byId;
export const galleryConfigSelector = state => state.galleries.configById;
export const loadingSelector = state => state.galleries.loading;

export const galleryForBoardgameSelector = createSelector(
  galleriesSelector,
  galleries => memoize(
    id => id && galleries[id]
  )
);

export const galleryConfigForBoardgameSelector = createSelector(
  galleryConfigSelector,
  config => memoize(
    id => id && config[id]
  )
);
